import { TFunction } from 'react-i18next';

export const formatProjectStatus = (status: boolean, archived: boolean, t: TFunction): string => {
  if (archived) {
    return t('ProjectItem.archived');
  }
  switch (status) {
    case true:
      return t('ProjectItem.active');
    case false:
      return t('ProjectItem.nonActive');
    default:
      return status;
  }
};
